---
title: "UML in Models and Frameworks: Proposing the Unified Modeling Language as a standard in business and technical models"
slug: uml-in-models-and-frameworks
type: paper
status: published
featured: true
summary: Proposes UML as a shared language across business and technical models — an early statement of architecture that can be executed rather than only drawn.
sitePublishedAt: "2026-09-18"
originalPublishedAt: "1999-01-01"
lastReviewedAt: "2026-09-18"
audiences:
  - product-developer
themes:
  - platform-architecture
  - product-lines
sourceUrl: https://www.academia.edu/7763931/UML_in_Models_and_Frameworks_Proposing_the_Unified_Modeling_Language_as_a_standard_in_business_and_technical_models
originalAuthor: Jay van Zyl
sourceRelationship: academic record; PDF hosted on Academia.edu
rightsStatus: outbound-only
seoDescription: 1999 paper by Jay van Zyl proposing UML as a standard across business and technical models.
canonicalPath: /research/uml-in-models-and-frameworks
authors:
  - Jay van Zyl
year: 1999
venue: Working paper / Rubico
publicationType: report
citation: "van Zyl, J. (1999). UML in Models and Frameworks: Proposing the Unified Modeling Language as a standard in business and technical models."
researchTheme: product-line-architecture
recordUrl: https://www.academia.edu/7763931/UML_in_Models_and_Frameworks_Proposing_the_Unified_Modeling_Language_as_a_standard_in_business_and_technical_models
---

The later EcosystemCode path — words, then UML, then a running system — continues this argument. Business and technical models should share a language.
